// extracted by mini-css-extract-plugin
module.exports = {"loadingTemplate":"loadingTemplate_loadingTemplate__dyIYe"};